import { TabProps } from "@insite/mobius/Tab";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { TYPOGRAPHY } from "@store/theme/design";
import { transitionHoverStyles } from "@store/theme/mixins";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

export default {
    defaultProps: {
        typographyProps: {
            forwardAs: "h3",
            transform: "uppercase",
            size: TYPOGRAPHY.size.smaller,
        },
        css: css`
            cursor: pointer;
            letter-spacing: ${TYPOGRAPHY.letterSpacing.large};
            padding: 10px 10px 4px;
            border-bottom: 2px solid ${getColor("common.border")};
            transition: ${transitionHoverStyles("color", "border-color")};

            &:hover,
            &:focus {
                border-bottom: 2px solid ${getColor("primary")};
                color: ${getColor("primary")};
            }

            ${({ selected }: TabProps) => {
                if (selected) {
                    return css`
                        border-bottom: 2px solid ${getColor("primary")};
                        color: ${getColor("primary")};
                    `;
                }
            }}

            ${props =>
                breakpointValuesMediaQueries(
                    props.theme,
                    [
                        {
                            values: ["10px 10px 4px", "10px 15px 8px", "12px 20px 10px", null, "12px 30px"],
                            properties: ["padding"],
                        },
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    groupDefaultProps: {
        cssOverrides: {
            wrapper: css`
                align-items: center;
                padding: 0;

                > div {
                    width: 100%;
                }
            `,
            tabContent: css`
                border: none;
                padding: 0;

                ${props =>
                    breakpointValuesMediaQueries(
                        props.theme,
                        [
                            {
                                values: ["26px", "30px", "36px", null, "55px"],
                                properties: ["padding-top"],
                            },
                        ],
                        mediaOptions.min,
                    )}
            `,
            tabGroup: css`
                flex-wrap: wrap;
                justify-content: center;
            `,
        },
    },
};
